import IztIcon from './src/izt-icon'

IztIcon.install = Vue => {
  Vue.component(IztIcon.name, IztIcon)
}

export default IztIcon